import { render, staticRenderFns } from "./My-progress-new.vue?vue&type=template&id=a1953b9c&scoped=true&"
import script from "./My-progress-new.vue?vue&type=script&lang=js&"
export * from "./My-progress-new.vue?vue&type=script&lang=js&"
import style0 from "./My-progress-new.vue?vue&type=style&index=0&id=a1953b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1953b9c",
  null
  
)

export default component.exports